export default {
  // Cortizol
  contentTypeList: {
    accessContentTypeView: [],
    createNewContent: [],
    duplicateContent: [],
    archiveRestoreContent: [],
  },
  contentTypeForm: {
    accessContentTypeFormView: [],
    savePublishContent: [],
  },
  mediaList: {
    accessMediaListView: [],
  },
  mediaEdit: {
    accessMediaEditView: [],
  },
  // Parazol
  users: {
    accessUserListView: [],
    accessUserNewView: [],
    updateUserProfile: [],
    updateUserEmailAddress: [],
    activateDeactivateUser: [],
  },
};
